// Open modal on play button click (delegated for single + bundle)
document.addEventListener('click', (e) => {
  const playButton =
    e.target.closest('.product-features__play-button') ||
    e.target.closest('.learn-more__play-button');

  if (!playButton) return;

  // Check for per-product modal (bundle) or single modal
  const videoContainer =
    playButton.closest('.product-features__video') ||
    playButton.closest('.learn-more__video');
  const productId = videoContainer ? videoContainer.dataset.productId : null;

  const modal = productId
    ? document.getElementById('productFeaturesModal-' + productId)
    : document.getElementById('productFeaturesModal');

  if (!modal) return;

  modal.style.display = 'block';
  document.body.style.overflow = 'hidden';

  const video = modal.querySelector('video');
  if (video) video.play();
});

// Close modal (delegated for all close buttons)
document.addEventListener('click', (e) => {
  const closeButton = e.target.closest('.product-features-modal__close');
  if (!closeButton) return;

  const modal = closeButton.closest('.product-features-modal');
  if (!modal) return;

  closeModal(modal);
});

// Close on overlay click
document.addEventListener('click', (e) => {
  if (!e.target.classList.contains('product-features-modal__overlay')) return;
  const modal = e.target.closest('.product-features-modal');
  if (modal) closeModal(modal);
});

// Close on ESC key
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  const openModal = document.querySelector(
    '.product-features-modal[style*="display: block"]'
  );
  if (openModal) closeModal(openModal);
});

function closeModal(modal) {
  modal.style.display = 'none';
  document.body.style.overflow = '';
  const video = modal.querySelector('video');
  if (video) {
    video.pause();
    video.currentTime = 0;
  }
}
